export interface IGetFhirPatientIconsRequest {
  patientIdentifier: string;
}
